import React from 'react';

interface MobileMenuButtonProps {
  isOpen: boolean;
  onToggle: () => void;
}

const MobileMenuButton: React.FC<MobileMenuButtonProps> = ({ isOpen, onToggle }) => {
  return (
    <div className="md:hidden flex justify-end items-end w-full">
      <button
        onClick={onToggle}
        className="inline-flex items-center justify-center p-2 rounded-md  hover:text-navgreen focus:outline-none focus:ring-2 focus:ring-navgreen"
        aria-expanded={isOpen}
      >
        <span className="sr-only">
          {isOpen ? "Close main menu" : "Open main menu"}
        </span>
        <div className="w-6 h-6 relative flex items-center justify-center">
          <span
            className={`absolute w-6 h-0.5 bg-current transform transition-all duration-300 ease-in-out ${
              isOpen ? "rotate-45" : "-translate-y-1.5"
            }`}
          ></span>
          <span
            className={`absolute w-6 h-0.5 bg-current transition-all duration-300 ease-in-out ${
              isOpen ? "opacity-0" : "opacity-100"
            }`}
          ></span>
          <span
            className={`absolute w-6 h-0.5 bg-current transform transition-all duration-300 ease-in-out ${
              isOpen ? "-rotate-45" : "translate-y-1.5"
            }`}
          ></span>
        </div>
      </button>
    </div>
  );
};

export default MobileMenuButton;